import { render, staticRenderFns } from "./m-restricted-field.vue?vue&type=template&id=0967d748&scoped=true&"
import script from "./m-restricted-field.vue?vue&type=script&lang=js&"
export * from "./m-restricted-field.vue?vue&type=script&lang=js&"
import style0 from "./m-restricted-field.vue?vue&type=style&index=0&id=0967d748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0967d748",
  null
  
)

export default component.exports